// extracted by mini-css-extract-plugin
export default {"editor":"editor___U0oYX","editor_readonly":"editor_readonly___i3RFc"};